import PropTypes from 'prop-types';
import React from 'react';

import { isFeatureEnabled } from 'common-src/models/FeatureFlag';
import { TemplateModuleType } from 'common-src/models/Template';

import useCustomSelector from 'src/hooks/useCustomSelector';

import CaregiverInfoModule from '../CaregiverInfoModule/CaregiverInfoModule';
import CGMAlertsModule from '../CGMAlertsModule/CGMAlertsModule';
import CGMEvaluationModule from '../CGMEvaluationModule';
import CognitiveScreeningModule from '../CognitiveScreeningModule';
import ConditionsModule from '../ConditionsModule';
import LabOrdersModule from '../LabOrdersModule';
import MedicationsModule from '../MedicationsModule';
import PatientInfoModule from '../PatientInfoModule/PatientInfoModule';
import Promis10Module from '../Promis10Module';
import ReferralsModule from '../ReferralsModule';
import RoutineExamsModule from '../RoutineExamsModule';
import SdohModule from '../SdohModule';
import VitalsAndLabsModule from '../VitalsAndLabsModule';
import WellnessPlanModule from '../WellnessPlanModule';

const DocumentModule = (props) => {
  const isSdohModuleEnabled = useCustomSelector((state) =>
    isFeatureEnabled(state, 'showSdohModule'),
  );
  switch (props.moduleType) {
    case TemplateModuleType.Sdoh:
      return isSdohModuleEnabled ? <SdohModule {...props} /> : null;
    case TemplateModuleType.CGMAlerts:
      return <CGMAlertsModule {...props} />;
    case TemplateModuleType.CGMEvaluation:
      return <CGMEvaluationModule {...props} />;
    case TemplateModuleType.VitalsAndLabs:
      return <VitalsAndLabsModule {...props} />;
    case TemplateModuleType.WellnessPlan:
      return <WellnessPlanModule {...props} />;
    case TemplateModuleType.RoutineExams:
      return <RoutineExamsModule {...props} />;
    case TemplateModuleType.Referrals:
      return <ReferralsModule {...props} />;
    case TemplateModuleType.LabOrders:
      return <LabOrdersModule {...props} />;
    case TemplateModuleType.CognitiveScreening:
    case TemplateModuleType.ZBI22:
      return (
        <CognitiveScreeningModule
          {...props}
          showOnlyZBI22={props.moduleType === TemplateModuleType.ZBI22}
        />
      );
    case TemplateModuleType.PatientInfo:
      return <PatientInfoModule {...props} />;
    case TemplateModuleType.CaregiverInfo:
      return <CaregiverInfoModule {...props} />;
    case TemplateModuleType.Promis10:
      return <Promis10Module {...props} />;
    case TemplateModuleType.Conditions:
      return <ConditionsModule {...props} />;
    case TemplateModuleType.Medications:
      return <MedicationsModule {...props} />;
    default:
      return null;
  }
};

DocumentModule.propTypes = {
  moduleType: PropTypes.string,
};

export default DocumentModule;
